import { render } from "./MetricReport.vue?vue&type=template&id=235158ac&ts=true"
import script from "./MetricReport.vue?vue&type=script&lang=ts"
export * from "./MetricReport.vue?vue&type=script&lang=ts"

import "./MetricReport.vue?vue&type=style&index=0&id=235158ac&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__